import axios from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { HierarchyReadDto } from "./HierarchyReadDto";

export type ICopyReportReturn = IAxiosReturn<HierarchyReadDto>;

export interface CopyReportDto {
  reportId: string;
  hierarchyId: string;
  newReportName: string;
  parentTag: string;
  description: string;
  reportType: string;
}

/**
 * Copy a report into a hierarchy as a new report name.
 *
 * @param backEndUrl - Base backend URL
 * @param params - Parameters for the copy operation
 * @param controller - Optional AbortController
 * @returns Newly created hierarchy information when successful
 */
export const copyReport = async (
  backEndUrl: string,
  params: CopyReportDto,
  controller?: AbortController,
): Promise<ICopyReportReturn> => {
  const url = `${backEndUrl}Reports/CopyReport/${params.reportId}`;
  try {
    const response = await axios.post(
      url,
      {
        hierarchyId: params.hierarchyId,
        newReportName: params.newReportName,
        parentTag: params.parentTag,
        description: params.description,
        reportType: params.reportType,
      },
      controller !== undefined ? { signal: controller.signal } : undefined,
    );
    return { success: true, data: response.data };
  } catch (error: unknown) {
    return processAxiosError("Copy report failed", error);
  }
};
